// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"navbar_Navbar__1oaQp","Link":"navbar_Link__3SXD-","Selected":"navbar_Selected__1PWyh","Links":"navbar_Links__21H8v"};